/** Returns true when the current host is a beta, local, or staging dashboard. */
export const isBetaHost = (href: string = window.location.href): boolean => {
  const currentURL = href.toLowerCase();
  return currentURL.includes('beta') || currentURL.includes('localhost') || currentURL.includes('homecook.space');
};
